const PreviewsCategoryItem = ({ isDesktop, desktopProps, analytics } : {isDesktop: boolean, desktopProps: {socialList: { key: string; description: string }[], previewCategory: string, previewSetCategory: Function, previewSetSelected: Function}, analytics: any}) => {
  if (!isDesktop) return;

  return getDesktopCategoryItem(
    desktopProps.socialList,
    desktopProps.previewCategory,
    desktopProps.previewSetCategory,
    desktopProps.previewSetSelected,
    analytics
  );
};

const getDesktopCategoryItem = (
  socialList,
  previewCategory,
  previewSetCategory,
  previewSetSelected,
  analytics
) => {
  return socialList.map((item: any, key: number) => {
    let icon = `icon__${item.key}`;
    icon += previewCategory === item.key ? ` ${icon}_active` : "";

    return (
      <li
        key={"socialItem" + key.toString()}
        className={`embla__slide social__list-item social__list-item_show ${
          previewCategory === item.key ? "social__list-item_active" : ""
        }`}
        onClick={() => {
          previewSetCategory(item.key);
          previewSetSelected([]);
          analytics.sendClickCategoryPreview(item.key);
        }}
      >
        <i className={icon} />
        <span>{item.description}</span>
      </li>
    );
  });
};

export default PreviewsCategoryItem;